import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import DealCard from "@/components/DealCard";
import { Plus } from "@phosphor-icons/react";

export default function MyLinks() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/my/links").then((r) => setLinks(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight">My <span className="text-[#FF007F]">Links</span></h1>
        <Link to="/submit" className="flex items-center gap-1 px-4 py-2 bg-[#FF007F] text-white text-xs font-bold uppercase tracking-widest border border-[#FF007F] hover:bg-[#09090B] hover:text-[#FF007F] transition-colors">
          <Plus size={16} weight="bold" /> Post New
        </Link>
      </div>
      {loading ? (
        <p className="text-zinc-500 font-mono">Loading…</p>
      ) : links.length === 0 ? (
        <div className="border border-dashed border-zinc-800 p-12 text-center text-zinc-400">
          You haven't posted any links yet. <Link to="/submit" className="text-[#00FFFF] underline">Post your first link</Link>.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {links.map((l, i) => <DealCard key={l.id} link={l} index={i} />)}
        </div>
      )}
    </div>
  );
}
